import React, { useState } from "react";
import { Link } from "react-router-dom";
import ContactForm from "../components/ContactForm";
import propostaImg from "../assets/images/banner02.jpeg";
import analiseImg from "../assets/images/banner01.webp";
import email from "../assets/images/ic_outline-email.png";
import zap from "../assets/images/zap.jpg";
import clubePinheiros from "../assets/images/clube.jpg";
import clube from "../assets/images/clube2.jpg";
import shopping from "../assets/images/shoppingd.jpg";
import pirelli from "../assets/images/Pirell.webp";
import edificio from "../assets/images/edificio.webp";
import hospital from "../assets/images/hosptal.jpg";
import sawem from "../assets/images/SawemIndustrial.jpg";

const Home = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleFormSubmit = (isSubmitted) => {
    setFormSubmitted(isSubmitted);
  };

  return (
    <div className="home-page">
      {/* Seção Hero */}

      <section id="home" className="hero-section text-center py-5">
        <div className="container-header py-5 px-3">
          <h1 className="display-4 fw-bold mb-4">
            Possibilidades da sua próxima conta justa e Eficiente!
          </h1>
          <h3 className="display-6 fw-bold mb-4 sub_title">
            TEMOS A EXPERTISE IDEAL PARA O SEU RAMO DE ATIVIDADE
          </h3>
        </div>
      </section>

      <section>
        <div className="row justify-content-center m-5 g-5 ">
          <div className="col-md-6 col-lg-5 col-xl-4">
            <div className="card card_main h-100 border-0 shadow-sm hover-shadow bg-light">
              <div className="card-img-container">
                <img src={propostaImg} alt="Proposta" className="card-img " />
              </div>
              <div className="card-body text-center py-3">
                <p className="card-text mb-0 fw-bold  ">
                  Apresentar a Proposta
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-5 col-xl-4 ">
            <div className="card card_main h-100 border-0 shadow-sm hover-shadow bg-light">
              <div className="card-img-container">
                <img
                  src={analiseImg}
                  alt="Análise de Viabilidade"
                  className="card-img "
                />
              </div>
              <div className="card-body text-center py-3">
                <p className="card-text mb-0  fw-bold">
                  Análise de Viabilidade
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Seção de Benefícios com ID para scroll */}
      <section
        id="beneficios"
        className="features-section py-5 bg-light section_sessao"
      >
        <div className="container g-5">
          <h2 className="text-center txt_title mt-0 mb-0">Nossas Vantagens</h2>

          {/* primeira linha com 2 cards */}
          <div className="row justify-content-center g-5 py-5">
            <div className="col-md-6 card_main col-lg-5 col-xl-4 ">
              <div className="card  h-100 border-2 shadow-sm hover-shadow min-vh-50 d-flex justify-content-center align-items-center">
                <div className=" text-center py-5 ">
                  <h1 className="card_body ">De acordo com a </h1>
                  <h1 className="card_body ">legislação e </h1>
                  <h1 className="card_body ">normas Técnicas</h1>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-5 col-xl-4 mb-2 ">
              <div className="card  card_main h-100 border-2 shadow-sm hover-shadow min-vh-50 d-flex justify-content-center align-items-center py-5 ">
                <div className=" text-center py-4 ">
                  <h1 className="card_body ">Análise a custo zero e</h1>
                  <h1 className="card_body "> acompanhamento das vistorias</h1>
                  <h1 className="card_body "> solicitadas a concessionária</h1>
                </div>
              </div>
            </div>
          </div>

          {/* segunda linha com 2 cards */}
          <div className="row justify-content-center g-5 mt-0">
            <div className="col-md-6 col-lg-5 col-xl-4 ">
              <div className="card h-100 border-2 shadow-sm hover-shadow min-vh-50 d-flex justify-content-center align-items-center">
                <div className=" text-center py-5 ">
                  <h1 className="card_body ">Redução do Valor</h1>
                  <h1 className="card_body ">da conta de Água</h1>
                  <h1 className="card_body ">e Esgoto</h1>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-5 col-xl-4 mb-2">
              <div className="card h-100 border-2 shadow-sm hover-shadow min-vh-50 d-flex justify-content-center align-items-center py-5">
                <div className=" text-center py-4 ">
                  <h1 className="card_body ">Assessoria </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Seção de Sobres com ID para scroll */}
      <section
        id="sobre"
        className="section_solucoes  mt-5  mb-5 features-section align-items-center py-5 section_sessao "
      >
        <div className="container  ">
          <h2 className="text-center txt_title mt-5 mb-2">Nossas Soluções</h2>

          <div className="row w-75  py-3 g-4 mx-auto mb-5 me-5 div_solucoes ">
            <h3>Como Funciona:</h3>

            <p className="div_solucoes mt-4">
              {" "}
              <strong>1.</strong> Envie uma fatura/conta de água ou esgoto (sem
              compromisso).
            </p>
            <p className="div_solucoes  mt-4">
              {" "}
              <strong>2.</strong> Realizamos um diagnóstico gratuito da
              viabilidade econômica.
            </p>
            <p className="div_solucoes  mt-4">
              {" "}
              <strong>3.</strong> Implementamos as melhorias e nossa remuneração
              será um percentual sobre o benefício conquistado, após
              demonstração comprovada.{" "}
            </p>
          </div>
        </div>
      </section>

      {/* Seção de Sobre nos com ID para scroll */}
      <section className="features-section py-5 bg-light section_sessao mb-5 ">
        <div className="container">
          <h1 className="text-center mb-5 fw-light">Quem Somos</h1>
          <h2 className="text-center fw-bold">Yasserv</h2>
          <div className="row g-4  justify-content-center align-items-center py-5 about_atuacao">
            <p className="text_about ms-5 text-wrap mt-0">
              YASSERV é uma Empresa de consultoria e Especialista em
              investigação hidráulica de abastecimento de água com experiência
              adquirida em mais de 12 anos de atuação na concessionária de água
              e esgoto.
            </p>
            <h3 className="text-start ms-5 p-0 ">Nossa Atuação:</h3>

            <p className="text-start ms-5 p-0 text_atuacao text-wrap">
              {" "}
              • Tudo começa com o envio das 3 últimas contas para uma análise
              minuciosa e sem compromisso.
            </p>

            <p className="text-start ms-5 p-0 text_atuacao text-wrap">
              {" "}
              • Acionamos a concessionária, solicitando:
            </p>

            <p className="text-start ms-5 mb-0 ps-4 text_atuacao text-wrap">
              {" "}
              ✓ Reavaliação cadastral dos serviços prestados;
            </p>
            <p className="text-start ms-5 mb-0 ps-4 text_atuacao text-wrap">
              {" "}
              ✓ Análise detalhada da conta para identificação e correção de
              eventuais irregularidades nas cobranças;
            </p>
            <p className="text-start ms-5 mb-0 ps-4 text_atuacao text-wrap">
              {" "}
              ✓ Adequação tarifária conforme os parâmetros regulatórios.
            </p>

            <p className="text-start ms-5 p-0 text_atuacao fw-semibold">
              {" "}
              • Solicite já a sua avaliação.
            </p>

            <h3 className="text-start ms-5 mb-0 mt-5 fw-bold">
              Diferenciais Competitivos:
            </h3>

            <p className="text-start ms-5 mb-0 ps-4 text_atuacao text-wrap">
              {" "}
              ✓ Honorários 100% sucesso: Só recebemos quando sua empresa já
              possuir o benefício.
            </p>
            <p className="text-start ms-5 mb-0 ps-4 text_atuacao text-wrap">
              {" "}
              ✓ Sem custos prévios: Não cobramos por visitas, diagnósticos ou
              despesas.
            </p>
          </div>

          <h2 className="text-center mt-4">Nosso Objetivo</h2>

          <p className="mt-4 text-center  text_atuacao text-wrap">
            {" "}
            Nosso objetivo é claro: maximizar a economia nas contas de água e
            esgoto poupando seu dinheiro para outros projetos ou investimentos.
          </p>

          <h4 className="text-center my-5 text-wrap">
            {" "}
            Conformidade assegurada: Todas as soluções seguem a legislação
            vigente e padrões das Agências Reguladoras.{" "}
          </h4>
        </div>
      </section>

      {/* Seção de Contatos */}
      <section
        id="contato"
        className="features-section bg-light section_sessao"
      >
        <div className="container mt-5 ">
          <h1 className="text-center mb-5 fw-light text_contato">
            Solicitar informações
          </h1>
          {formSubmitted ? (
            <div className="alert alert-success text-center  align-items-center">
              <h4>✅ Obrigado pelo seu contato!</h4>
              <p>Retornaremos em breve.</p>
              <button
                className="btn btn-primary mt-3 w-50"
                onClick={() => setFormSubmitted(false)}
              >
                Enviar nova mensagem
              </button>
            </div>
          ) : (
            <div className="row py-2">
              <div className="col-md-6  form_mongo align-items-center ">
                <ContactForm onFormSubmit={handleFormSubmit} />
              </div>
              <div className="col-md-6 div_contatos py-5">
                <h3 className="">Atendimento pelos Canais </h3>
                <h3 className="mb-4"> via E-mail e Whatsapp </h3>

                <p>
                  <a
                    href="https://wa.me/5511921873396"
                    target="_blank"
                    rel="noopener noreferrer"
                    className=""
                  >
                    <img
                      src={zap}
                      alt="Logo do site"
                      width="30"
                      height="28"
                      className="me-1"
                    />
                    1192187-3396
                  </a>
                </p>
                <p>
                  <a href="consultoria@yasserv.com.br" className="">
                    <img
                      src={email}
                      alt="Logo do site"
                      width="30"
                      height="28"
                      className="me-1"
                    />
                    consultoria@yasserv.com.br
                  </a>
                </p>
                <div className="mt-4 div_atendimento">
                  <h4>Horário de atendimento:</h4>
                  <p>Segunda a Sexta: 8h às 18h</p>
                  <p>Sábado: 8h às 12h</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Seção de clientes 
      <section
        id="contato"
        className="features-section mt-5 py-5 bg-light section_sessao "
      >
        <div className="container mt-2 mb-1   tablet_section">
          <h2 className="text-center mb-5">Serviços Realizados</h2>

          <div className="row g-4 mt-5 justify-content-center">
            <div className="col-md-3 tablet_section">
              <div className="card h-70 border-0 shadow-sm hover-shadow">
                <div className="card-body  card-body-mobile text-center p-0">
                  <img
                    src={clubePinheiros}
                    alt="Logo do site"
                    className="p-0"
                  />
                </div>
              </div>
            </div>

            <div className="col-md-3 tablet_section">
              <div className="card h-70 border-0 shadow-sm hover-shadow">
                <div className="card-body   card-body-mobile text-center p-0">
                  <img src={clube} alt="Logo do site" className="p-0" />
                </div>
              </div>
            </div>

            <div className="col-md-3 tablet_section">
              <div className="card h-70 border-0 shadow-sm hover-shadow">
                <div className="card-body  card-body-mobile text-center p-0">
                  <img src={pirelli} alt="Logo do site" className="p-0" />
                </div>
              </div>
            </div>

            <div className="col-md-3 tablet_section">
              <div className="card h-70 border-0 shadow-sm hover-shadow">
                <div className="card-body   card-body-mobile text-center p-0">
                  <img src={sawem} alt="Logo do site" className="p-0 w-100" />
                </div>
              </div>
            </div>

            <div className="col-md-3 tablet_section ">
              <div className="card h-70 border-0 shadow-sm hover-shadow">
                <div className="card-body  card-body-mobile text-center p-0">
                  <img src={shopping} alt="Logo do site" className="p-0" />
                </div>
              </div>
            </div>

            <div className="col-md-3 tablet_section">
              <div className="card h-70 border-0 shadow-sm hover-shadow">
                <div className="card-body  card-body-mobile text-center p-0">
                  <img src={edificio} alt="Logo do site" className="p-0" />
                </div>
              </div>
            </div>

            <div className="col-md-3  tablet_section">
              <div className="card h-70 border-0 shadow-sm hover-shadow">
                <div className="card-body card-body-mobile text-center p-0">
                  <img src={hospital} alt="Logo do site" className="p-0" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
       */}
      <section className="features-section py-3 bg-light section_bottom section_sessao mb-0  mt-5">
        <div className="container ">
          <h2 className="text-center fw-bold mb-1 mt-1">Yasserv</h2>

          <h2 className="text-center fw-light mt-3 mb-5">
            CONSULTORIA EMPRESARIAL{" "}
          </h2>
        </div>
      </section>
    </div>
  );
};

export default Home;
